import {Component} from '@angular/core';

@Component({
  selector: 'to-generate',
  templateUrl: './to-generate.component.html',
  styleUrls: ['./to-generate.component.scss'],
})
export class ToGenerateComponent {
}
